{
  "title": "Stock Adjustment",
  "subtitle": "Correct on-hand quantities for damage, loss, found stock, or manual correction.",
  "add": "New Adjustment",
  "edit": "Edit",
  "commit": "Commit",
  "table": {
    "number": "Adjustment #",
    "warehouse": "Warehouse",
    "reason": "Reason",
    "date": "Date",
    "lines": "Lines",
    "status": "Status"
  },
  "form": {
    "warehouse": "Warehouse",
    "reason": "Reason",
    "material": "Material",
    "location": "Location",
    "none": "None",
    "adjustedQty": "New Qty",
    "remarks": "Remarks",
    "addLine": "Add Line",
    "resolvedBatch": "Batch: {{batchNo}}",
    "resolvedClient": "Client: {{clientName}}",
    "scanNeedsLabel": "That is a material barcode, not a printed stock label. Scan the label on the physical unit.",
    "scanDuplicate": "That unit has already been scanned on this adjustment.",
    "barcodePickerHint": "Barcode Required is on. Pick a material, then tick the units you are correcting — or scan them. Units the system no longer counts are listed too, so found stock can be put back on.",
    "unitsTitle": "Units of this material",
    "noUnits": "No barcoded units exist for this material. Print labels for it first.",
    "unitMeta": "Qty {{qty}} · {{source}} label · Batch {{batch}} · {{location}}",
    "unitDispatched": "Dispatched — found",
    "unitNotPutAway": "Not put away — found",
    "foundQty": "Actual qty",
    "foundAt": "Found at",
    "scannedElsewhere": "Scanned units not in the list above",
    "selectedCount": "{{count}} unit(s) selected.",
    "stockSummary": "On hand {{onHand}} · Available {{available}} · Reserved {{allocated}}",
    "unitsHidden": "Showing {{onHand}} unit(s) to match stock on hand. {{count}} further label(s) are still recorded in stock but are not covered by it — stale records from stock issued without its labels being retired.",
    "unitConsumed": "Issued out — found"
  },
  "save": "Save",
  "cancel": "Cancel",
  "statusChange": {
    "action": "Change Stock Status",
    "title": "Change Stock Status",
    "subtitle": "Move quantity between Available, Quarantine, Blocked and Damaged. The physical quantity does not change.",
    "sourceRow": "Stock to reclassify",
    "sourceRowHelp": "Only stock that is not already reserved for an open pick list can be reclassified.",
    "noStock": "No stock is currently held anywhere.",
    "rowLabel": "{{materialCode}} — {{status}} — {{location}} — {{movable}} available",
    "noLocation": "No location",
    "toStatus": "New status",
    "qty": "Quantity",
    "remarks": "Reason / remarks",
    "movable": "Movable: {{qty}}",
    "submit": "Change Status",
    "success": "Stock status changed.",
    "unitsTitle": "Units to reclassify",
    "selectAll": "Select all",
    "clearAll": "Clear all",
    "noUnits": "No barcoded units are recorded at this location for this status, so nothing can be reclassified here. Print labels for this stock first.",
    "unitMeta": "Qty {{qty}} · {{source}} label · Batch {{batch}}",
    "qtyFromUnits": "Calculated from {{count}} selected unit(s)."
  }
}
